import { createSlice } from '@reduxjs/toolkit'

// PoC: query for the hybrid full-text + vector search (GET /api/footages/search).
// Kept out of footageFilters so it doesn't leak into /api/footages params or the URL.
const initialState = {
	query: '',
}

const footageSemanticSearch = createSlice({
	name: 'FOOTAGE.SEMANTIC_SEARCH',
	initialState,
	reducers: {
		setSemanticQuery(state, { payload: query }) {
			state.query = query
		},

		clearSemanticQuery(state) {
			state.query = ''
		},
	},
})

export const { setSemanticQuery, clearSemanticQuery } = footageSemanticSearch.actions

export default footageSemanticSearch.reducer
